import { render } from "./BackendOfficeSolutionView.vue?vue&type=template&id=9dbbb82a"
import script from "./BackendOfficeSolutionView.vue?vue&type=script&lang=js"
export * from "./BackendOfficeSolutionView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__